import ShipmentSection from './shipment-section';

export default ShipmentSection;